import * as API from '../_api';

const randomId = () => `_${Math.random().toString(36).substr(2, 9)}`;

export const create = async ({ dispatch }, { user, image }) => {
  try {
    if (image) {
      const imageName = `${randomId()}.${image.name.split('.').pop()}`;
      await API.uploadMemberImage(imageName, image);
      user.imageUrl = `https://images.einkaufskreis.at/member/${imageName}`;
    } else {
      throw new Error('Image is missing');
    }
    await API.create(user);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const read = async ({ commit, dispatch }) => {
  try {
    const all = await API.read();
    commit('setAll', all);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const update = async ({ dispatch }, { user, image }) => {
  try {
    if (image) {
      const imageName = `${randomId()}.${image.name.split('.').pop()}`;
      await API.uploadMemberImage(imageName, image);
      user.imageUrl = `https://images.einkaufskreis.at/member/${imageName}`;
    }

    await API.update(user);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};

export const del = async ({ dispatch }, user) => {
  try {
    await API.del(user);
    return true;
  } catch (ex) {
    dispatch('snackbar/error', ex.message ? ex.message : ex, { root: true });
    return false;
  }
};
